import { ExceptionTypeColoursPipe } from "./exception-type-colours.pipe";
import { WeekdayNamesPipe } from "./weekday-names.pipe";
import { DisplayNameCustomBoldPipe } from "./display-name-custom-bold.pipe";
import { UnabbreviateEmploymentStatusPipe } from "./unabbreviate-employment-status.pipe";
import { FormatHoursDecimalsPipe } from "./format-hours-decimals.pipe";

export const pipes: any[] = [
    WeekdayNamesPipe,
    ExceptionTypeColoursPipe,
    DisplayNameCustomBoldPipe,
    UnabbreviateEmploymentStatusPipe,
    FormatHoursDecimalsPipe
];

export * from "./weekday-names.pipe";
export * from "./exception-type-colours.pipe";
export * from "./display-name-custom-bold.pipe";
export * from "./unabbreviate-employment-status.pipe";
export * from "./format-hours-decimals.pipe";